/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliSubjectDtoApiResponse } from '../../models/amoxcalli-subject-dto-api-response';
import { AmoxcalliUpdateSubjectDto } from '../../models/amoxcalli-update-subject-dto';

export interface ApiSubjectsIdPut$Plain$Params {
  id: string;
      body?: AmoxcalliUpdateSubjectDto
}

export function apiSubjectsIdPut$Plain(http: HttpClient, rootUrl: string, params: ApiSubjectsIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliSubjectDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiSubjectsIdPut$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliSubjectDtoApiResponse>;
    })
  );
}

apiSubjectsIdPut$Plain.PATH = '/api/subjects/{id}';
